/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { RestrictionMixin } from './RestrictionMixin';
import { RestrictionNotSetSessionLockdown } from './RestrictionNotSetSessionLockdown';
import { RestrictionSetSessionLockdown } from './RestrictionSetSessionLockdown';
const RestrictionParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    [
        'sessionLockdown',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['set', RestrictionSetSessionLockdown],
            ['not-set', RestrictionNotSetSessionLockdown],
        ]),
        'session_lockdown',
    ],
]), RestrictionMixin);
export class Restriction extends RestrictionMixin {
    static decode(input) {
        return RestrictionParser.decode(input).map(res => new Restriction(res));
    }
    static unsafeDecode(input) {
        return Restriction.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RestrictionParser.encode(data);
    }
    static schema() {
        return RestrictionParser.schema();
    }
}
